module.exports = __webpack_public_path__ + "img/Marc2000tower.99b9cdcb.jpg";